export { FALLBACK_TOP_NAV_RESPONSE, AccountsMenuLinks, logOutLink, moveZapsLink, settingsLink, } from './links';
export const signupPath = '/sign-up/';
export const loginPath = '/app/login';
export const skipLinkHref = '#mainContent';
export const UNIVERSAL_NAV_ZINDEX = 950;
export const UNIVERSAL_NAV_SUBMENU_ZINDEX = UNIVERSAL_NAV_ZINDEX + 1;
export const UNIVERSAL_TOPBAR_HEIGHT = 56;
export const UNIVERSAL_TOPBAR_CONDENSED_HEIGHT = 56;
export const UNIVERSAL_SIDEBAR_WIDTH = 240;
export const UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH = 52;
export const BREAKPOINT_UNIVERSAL_SIDEBAR_SHOW_COLLAPSED = 1040;
export const BREAKPOINT_UNIVERSAL_SIDEBAR_SHOW_OPEN = 1440;
//# sourceMappingURL=index.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
